import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bs87t4kkpd: FaireBrandEntity = {
  token: "b_bs87t4kkpd",
  type: "brand",
  name: "Strange Water",
  location: "Los Angeles, CA, USA",
  isTopShop: true,
  meta: {
    source: "snowflake",
    importedAt: "2026-09-29T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
